export const countriesWithRequiredState = ['us', 'au', 'ca', 'mx', 'th', 'cn', 'id', 'my', 'vn'];
